import { readOrderQuery, writeOrderQuery } from './orderQuery';

export const ORDER_PREFERENCES_PREFIX = 'bee:order-view:v1:';
const preferenceKey = (username) =>
  ORDER_PREFERENCES_PREFIX + encodeURIComponent(username);
const rememberedFields = [
  'storeName',
  'statusList',
  'amzStatusList',
  'pageSize',
  'sortBy',
  'sortDirection',
];

export const readOrderPreferences = (username) => {
  try {
    const saved = JSON.parse(localStorage.getItem(preferenceKey(username)));
    return {
      query: readOrderQuery(new URLSearchParams(saved?.query || '')),
      expandedColumns: saved?.expandedColumns === true,
    };
  } catch {
    return {
      query: readOrderQuery(new URLSearchParams()),
      expandedColumns: false,
    };
  }
};

export const saveOrderPreferences = (username, query, expandedColumns) => {
  if (!username) return;
  const remembered = Object.fromEntries(
    rememberedFields.map((key) => [key, query[key]]),
  );
  try {
    localStorage.setItem(
      preferenceKey(username),
      JSON.stringify({
        query: writeOrderQuery(remembered).toString(),
        expandedColumns,
      }),
    );
  } catch {
    // Storage can be disabled; the current session still retains its view.
  }
};
